import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProjectorStore = defineStore('projector', () => {
  const {
    items: projectors,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('api/library/projector');

  const personal = ref([]);
  const global = ref([]);
  const fetchGlobal = async () => {
    const overrideUrl = `/api/library/projector?disguise_only=true`;
    const response = await fetch(null, overrideUrl);
    global.value = response && response.length > 0 ? response : [];
    return response;
  };

  const fetchSelf = async () => {
    const overrideUrl = `/api/library/projector?self_only=true`;
    const response = await fetch(null, overrideUrl);
    personal.value = response && response.length > 0 ? response : [];
    return response;
  };

  const getProjectorDataByCode = (code) => {
    const allProjectors = [...(personal.value || []), ...(global.value || [])];
    return allProjectors.find((projector) => projector.code === code);
  };

  return {
    projectors,
    fetch,
    destroy,
    update,
    store,
    personal,
    global,
    fetchGlobal,
    fetchSelf,
    getProjectorDataByCode,
  };
});
